import { type InternalContact } from '../../../Admin/InternalContacts/types';
import { type CreateInternalContactInput } from '../../../API';
import { type DbCreated } from '../types';

export const internalContactSyncItemFields = `
    id
    deleted
    name
    phone
    email
    workingHours
    _version
    _deleted
    _lastChangedAt
`.trim();

export const internalContactFromDb = (input: CreateInternalContactInput & DbCreated): InternalContact => ({
    id: input.id,
    type: input.type,
    name: input.name,
    phone: input.phone ?? null,
    email: input.email ?? null,
    workingHours: input.workingHours ?? null,
    position: input.position ?? null,
    departments: input.departments ? input.departments : [],
    description: input.description ?? null,
    deleted: input.deleted ?? false,
    order: input.order ?? null,
    _version: input._version ?? null,
    _lastChangedAt: input._lastChangedAt ?? null,
});
